<!--
 * @Description:
  1.第一层显示有些特殊  剩下的层级递归处理
  2.因为是inline-block  所以注意字体设置为0 如果显示有问题就是没有设置字体
-->
<template>
  <div style="padding:16px">
    <div style="margin:0px 0 16px 0">
      <a class="blueBtnMin" @click="openAddAccount">+Add new member</a>
    </div>
    <div class="accountList">
      <div class="listTr fgBg">
        <div class="listTd" style="text-align:center;width:16%"><span>Name</span></div>
        <div class="listTd" style="width:18.8%"><span>Email</span></div>
        <div class="listTd" style="width:12.8%"><span>Position</span></div>
        <div class="listTd" style="width:14.8%"><span>Account permissions</span></div>
        <div class="listTd" style="width:9.6%"><span>Status</span></div>
        <div class="listTd" style="width:28%"><span>Action</span></div>
      </div>
      <div v-if="isMaster || userInfoList.RootCustomerID===0" class="ebBG listTr">
        <div class="listTd" style="width:16%;font-size:0">
          <i class="marL10 fa fa-star"></i>
          <div style="display: inline-block;vertical-align: top;width:60%;">
            <el-tip :content="userInfoList.UserName"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:18.8%">
          <div>
            <el-tip :content="userInfoList.Mail"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:12.8%">
          <span>admin</span>
        </div>
        <div class="listTd" style="width:14.8%"><span>admin</span></div>
        <div class="listTd" style="width:9.6%"><span>Enable</span></div>
        <div class="listTd" style="overflow:hidden;width:28%">
        </div>
      </div>
      <div v-else class="listTr blueBG">
        <div class="listTd" style="width:16%;font-size:0">
          <div style="padding-left:30px">
            <el-tip :content="curUser.UserName"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:18.8%">
          <div>
            <el-tip :content="curUser.Mail"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:12.8%">
          <div>
            <el-tip :content="curUser.Position"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:14.8%"><span>{{curUser.RightValue === 1 ? 'Assistant' : 'User'}}</span></div>
        <div class="listTd" style="width:9.6%"><span>{{curUser.Status ? 'Enable' : 'Prohibit'}}</span></div>
        <div class="listTd" style="overflow:hidden;width:28%">
        </div>
      </div>
      <div v-for="(item,index) in workGroup.Children" :key="index">
        <div class="listTr blueBG">
          <div class="listTd" style="width:16%;font-size:0">
            <div class="clearance"></div>
            <div class="clearance" v-if="item.RightValue===1"></div>
            <template v-if="item.RightValue===2">
              <div v-show="nextId.includes(item.CustomerID)  && needLineData" class="user-speared marR10">
                <i class="fa fa-xdian dian"></i>
              </div>
              <div v-show="nextId.includes(item.CustomerID)  && !needLineData" class="user-speared-no marR10"></div>
              <div v-show="!nextId.includes(item.CustomerID)" class="user-speared-no marR10"></div>
            </template>
            <div class="Name" style="width:60%">
              <div>
                <el-tip :content="item.UserName"></el-tip>
              </div>
            </div>
            <div class="spread" v-if="item.Children.length">
              <i @click="spreadOut(item)" class="fa fa-xArrow" :class="nextId.includes(item.CustomerID)?'tran180':''"></i>
            </div>
          </div>
          <div class="listTd " style="width:18.8%">
            <div>
              <el-tip :content="item.Mail"></el-tip>
            </div>
          </div>
          <div class="listTd" style="width:12.8%">
            <div>
              <el-tip :content="item.Position"></el-tip>
            </div>
          </div>
          <div class="listTd" style="width:14.8%"><span>{{item.RightValue === 1 ? 'Assistant' : 'User'}}</span></div>
          <div class="listTd" style="width:9.6%"><span>{{item.Status ? 'Enable' : 'Prohibit'}}</span></div>
          <div class="listTd" style="overflow:hidden;width:28%">
            <div style="font-size:0">
              <a class="w68h24BtnL " @click="StatusChange(item)">{{item.Status ? 'Prohibit' : 'Enable'}}</a>
              <a class="lineBlueBtnMin " @click="openEditAccount(item)">Edit</a>
              <a class="lineBlueBtnMin " @click="resetPassTip(item)">Reset password</a>
            </div>
          </div>
        </div>
        <div class="listTr">
          <recursion-list :list="item" :needLine="needLineData" v-if="isShowChild(item)" :assant="isNextAss" :curId="nextId"></recursion-list>
        </div>
      </div>
      <add-account ref="addChild"></add-account>
      <edit-account ref="editChild"></edit-account>
    </div>
  </div>
</template>
<script>
import bus from '@/ask/eventBus';
import { post, fetch } from "@/ask/axios";
import { elAlert, elConfirm } from '@/utils/bulletBox'
import { getCustomer, setCustomer } from "@/utils/getCustomer";
import RecursionList from "@/components/userCenter/public/basicInfo/recursionList";
import AddAccount from "@/components/userCenter/public/basicInfo/addAccount";
import EditAccount from "@/components/userCenter/public/basicInfo/editAccount";
import UpdatePass from "@/components/userCenter/public/basicInfo/updatePass";
import ElTip from "@/components/userCenter/public/elTip";
export default {
  name: "workTable",
  components: { RecursionList, AddAccount, EditAccount, ElTip },
  props: {
    UserInfo: Object, //用户信息
  },
  data() {
    return {
      workGroup: {}, //列表显示
      nextId: [], //传到下级去的  当前展开id的集合
      level: "",//当前等级
      isMaster: false,//当前等级
      isNextAss: [], //分发给下级的助理
      needLineData: true,//需要线条
      curUser: {},//当前账号信息
      userInfoList: {},
    }
  },
  computed: {
    // 计算属性的 getter

  },
  created() {
    bus.$on('openEditAccount', (item) => {
      if (item) {
        this.openEditAccount(item)
      }
    })
    this.userInfoList = this.UserInfo;
    // 从sessionstroge获取用户信息后 调用获取列表
    getCustomer().then((Customer) => {
      if (Customer) {
        // this.UserInfo = Customer
        this.userInfoList = Customer;
        // this.UserInfo = Customer
        //console.log(Customer)
        this.level = Customer.Level
        this.getWorkGroup()
      }
    }).catch((error) => {
    })
  },
  methods: {
    // -------子账号展开
    spreadOut(item) {
      if (!this.nextId.length) {
        this.nextId.push(item.CustomerID)
        return
      }
      for (let i = 0; i < this.nextId.length; i++) {
        if (this.nextId[i] == item.CustomerID) {
          this.nextId.splice(i, 1)
          return
        }
      }
      this.nextId.push(item.CustomerID)
    },
    // 获取工作组 接口依赖用户信息
    getWorkGroup() {
      // let url = this.$api02 + '/api/EbayCustomer/WorkGroup/GetWorkGroupInfo';
      let url = this.$api04 + '/Basics/api/CustomerWorkGroup/GetWorkGroupInfo';
      let param = {}
      post(url, param).then((res) => {
        if (res.IsOK) {
          if (res.Results.length > 0) {
            this.loopHandle(res.Results)
          } else {
          }
        }
      })
    },
    // 是否需要线条
    isShowChild(item) {
      if (item.Children.length) {
        return true
      } else {
        if (this.isNextAss.length) {
          let isChild = this.isNextAss.filter((ele) => {
            return item.CustomerID === ele.OwnerCustomerID
          })
          if (isChild.length) {
            this.needLineData = false
            return true
          }
        }
        return false
      }
    },
    // 找出当前的用户账号  如果是助理就找他的上级用户 将当前所有助理都插入到这个用户的所有下级
    //下级通过id判断是否是这个账号的children 是就加不是就不加
    loopHandle(data) {
      this.curUser = data.filter((item) => {
        return item.CustomerID === this.userInfoList.CustomerID
      })[0]
      data = data.filter((item) => {
        return item.CustomerID !== this.userInfoList.CustomerID || item.RightValue === 2
      })
      // 当前账号信息
      let curUser = data.filter((item) => {
        return item.RightValue === 2
      })[0]
      if (curUser.RootCustomerID === curUser.CustomerID && curUser.CustomerID === this.userInfoList.CustomerID) {
        this.isMaster = true
      } else {
        this.isMaster = false
      }
      // 所有助理
      let allAssant = data.filter((item) => {
        return item.RightValue === 1
      })
      // 将所有助理插入到下级 如果不是属于下级的  下级将会删除它
      curUser.Children.unshift(...allAssant)
      // 将不是当前的分发给子元素领取
      this.isNextAss = curUser.Children.filter((item) => {
        return curUser.CustomerID !== item.OwnerCustomerID && item.RightValue === 1
      })
      curUser.Children = curUser.Children.filter((item) => {
        return curUser.CustomerID === item.OwnerCustomerID || item.RightValue === 2
      })
      this.workGroup = curUser

    },
    // 编辑
    openEditAccount(item) {
      this.$refs.editChild.clkDialog(item);
    },
    // 状态变更
    StatusChange(curItem) {
      let url = this.$api02 + '/api/EbayCustomer/WorkGroup/EditChildAccountStatus';
      let param = {
        CustomerId: curItem.CustomerID,
        Status: !curItem.Status,
      }
      post(url, param).then((res) => {
        if (res.IsOK) {
          curItem.Status = !curItem.Status
          elAlert(this, "success")
        } else {
          elAlert(this, "fail")
        }
      })
    },
    resetPassTip(curItem) {
      let tip = `The password will be sent to the account mailbox, please confirm to reset the password?`
      elConfirm(this, tip).then(() => {
        this.resetPass(curItem)
      }).catch(() => {
      })
    },
    // 重置密码
    resetPass(curItem) {
      // console.log(curItem)
      let url = this.$api02 + '/api/EbayCustomer/WorkGroup/WorkingGroupResetPwd';
      let param = {
        Email: curItem.Mail,
        CustomerID: curItem.CustomerID,
        RootCustomerID: curItem.RootCustomerID
      }
      post(url, param).then((res) => {
        if (res.IsOK) {
          elAlert(this, "success")
        } else {
          elAlert(this, "fail")
        }
      })
    },
    // 添加子账号
    openAddAccount() {
      this.$refs.addChild.clkDialog(this.userInfoList);
    },
  }
};
</script>
<style scoped>
@import "../../../../assets/css/userCenterCss.css";
@import "../../../../assets/css/frame.css";
.marL35 {
  margin-left: 35px;
}
.spread {
  display: inline-block;
  overflow: hidden;
  font-size: 16px;
  height: 40px;
  line-height: 35px;
  text-align: center;
  box-sizing: border-box;
  width: 20px;
}
.Name {
  display: inline-block;
  overflow: hidden;
  font-size: 12px;
}
.clearance {
  box-sizing: border-box;
  width: 15px;
  display: inline-block;
  height: 40px;
  vertical-align: top;
}
.user-speared > .fa-xdian {
  position: absolute;
  left: 6px;
  top: -13px;
  color: #a4a4a4;
  font-size: 20px;
}
.fa-xArrow {
  cursor: pointer;
}
.user-speared {
  position: relative;
  border-right: 2px solid #e5e5e5;
  width: 15px;
  font-size: 12px;
  height: 20px;
  display: inline-block;
  vertical-align: top;
  margin-top: 24px;
  font-size: 0;
}
.user-speared-no {
  position: relative;
  width: 15px;
  font-size: 12px;
  height: 20px;
  display: inline-block;
  vertical-align: top;
  margin-top: 24px;
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/basicInfo/workGroupList.vue